import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import QRCode from "qrcode";
import Drawer from "@mui/material/Drawer";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { alertMessage } from "../../actions/auth";
import { Bar } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { Chart } from "chart.js/auto";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Fab } from "@mui/material";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PublishIcon from "@mui/icons-material/Publish";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import { API_URL } from "../../actions/auth";
import { themeStyle } from "../../components/Components";
import AddIcon from "@mui/icons-material/Add";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material";
import { CloudUpload, Description, Close } from "@mui/icons-material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CheckIcon from "@mui/icons-material/Check";

const colorList = [
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
];
const colorList2 = [
  "#2ca25f",
  "#8856a7",
  "#e34a33",
  "#1c9099",
  "#636363",
  "#c51b8a",
  "#756bb1",
  "#31a354",
  themeStyle.primaryColor,
  "#e6550d",
];

const Dropzone = styled("div")(({ theme }) => ({
  border: `2px dashed ` + themeStyle.primaryColor,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(6),
  textAlign: "center",
  cursor: "pointer",
}));

const FileUploadCard = () => {
  return (
    <Box sx={{ maxWidth: 400, mx: "auto", marginBottom: "50px" }} elevation={1}>
      <Dropzone>
        <CloudUpload
          fontSize="large"
          sx={{ color: themeStyle.primaryColor, mb: 1, fontSize: "50px" }}
        />
        <Typography variant="body1">Click here to upload your file</Typography>
        <Typography variant="caption" color="text.secondary">
          with .xlsx file extension (Max 25MB)
        </Typography>
      </Dropzone>
    </Box>
  );
};

function InventoryPrincipal() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [imgError, setImgError] = useState(false);
  const [ogInventory, setOGInventory] = useState([]);
  const [random, setRandom] = useState(0);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [search, setSearch] = useState("");
  const [product, setProduct] = useState({});
  const [open, setOpen] = useState(false);
  const [isUploading, setIsUploading] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [inventoryList, setInventoryList] = useState([]);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [select, setSelect] = useState("Electronics");
  const [inventoryName, setInventoryName] = useState("");
  const [minimum, setMinimum] = useState("");
  const [inventoryDescription, setInventoryDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isPerishable, setIsPerishable] = useState(false);
  const [stock, setStock] = useState("");
  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "INVENTORY"
  );
  const [approvalsList, setApprovals] = useState([]);

  const handlePageSelect = (event) => {
    setSelectedPage(event.currentTarget.value);
  };

  function handleSearch(text) {
    setSearch(text);
    if (text.length == 0) {
      setInventoryList(ogInventory);
      setSearch("");
      setRandom(makeid(5));
    } else {
      var tempStudents = [];

      for (var i = 0; i < ogInventory.length; i++) {
        if (
          ogInventory[i]["name"].toLowerCase().includes(text.toLowerCase()) ||
          ogInventory[i]["category"].toLowerCase().includes(text.toLowerCase())
        ) {
          tempStudents.push(ogInventory[i]);
        }
      }
      setCurrentPage(1);
      setInventoryList(tempStudents);
      setRandom(makeid(5));
    }
  }

  function handleResolution(index, resolution) {
    var newApprovalsList = approvalsList;
    delete newApprovalsList[index]["resolution"];
    newApprovalsList[index]["resolution"] = resolution;
    setRandom(makeid(2));
    setApprovals(newApprovalsList);
  }

  function resolveApproval(id, status, resolution) {
    console.log(id, status, resolution);
    setIsSubmitting(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body["name"] = state.auth.user.full_name;
    body["request_id"] = id;
    body["resolution"] = resolution;
    body["user_id"] = state.auth.user.user_id;
    body["status"] = status;
    body["date"] = moment().format("DD-MM-YYYY");
    body = JSON.stringify(body);
    axios
      .post(API_URL + "/approve_request_inventory", body, config)
      .then((res) => {
        getInventory();
        setIsSubmitting(false);
        createAlert("SUCCESS", "Success.", "Approval " + status);
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function handleCurrentPage(val) {
    var tempStudents = Array.from(ogInventory);
    setSearch("");
    setCurrentPage(val);
    setInventoryList(tempStudents.splice((val - 1) * 25, 25));
  }

  function getInventory() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_inventory", body, config)
      .then((res) => {
        setProduct(res.data["inventory"][0]);
        setImgError(false);
        setOGInventory(res.data["inventory"]);
        setInventoryList(Array.from(res.data["inventory"]).splice(0, 25));
        setApprovals(res.data["approvals"]);
        setRandom(makeid(4));
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getInventory();
    }
  }, []);

  function getContent() {
    if (selectedPage == "INVENTORY") {
      return (
        <div>
          {inventoryList.length == 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "40px",
              }}
            >
              <SearchOffIcon
                style={{
                  fontSize: "200px",
                  marginBottom: "20px",
                  color: themeStyle.primaryColor,
                }}
              />
              <Typography
                variant="h6"
                style={{ color: themeStyle.primaryColor }}
              >
                No inventory found in records
              </Typography>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  padding: "25px",
                }}
              >
                <Grid container spacing={3} justifyContent={"flex-end"}>
                  <Grid item md={4}>
                    <div
                      style={{
                        backgroundColor: themeStyle.primaryCardColor,
                        borderRadius: "15px",
                        padding: "15px",
                        height: "100%",
                      }}
                    >
                      {imgError ? (
                        <div
                          style={{
                            maxWidth: "100%",
                            borderRadius: "15px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{ height: "200px" }}
                            src={require("../../img/inventory.png")}
                          />
                        </div>
                      ) : (
                        <img
                          style={{ maxWidth: "100%", borderRadius: "15px" }}
                          src={API_URL + "/media/" + product.inv_id + ".jpg"}
                          onError={() => {
                            setImgError(true);
                          }}
                        />
                      )}
                      <div
                        style={{
                          color: themeStyle.primaryColor,
                          fontSize: "25px",
                          fontWeight: "bold",
                        }}
                      >
                        {product.name}
                      </div>
                      <div
                        style={{
                          color: "black",
                          fontSize: "20px",
                        }}
                      >
                        {product.description}
                      </div>
                      <br />
                      <span
                        style={{
                          fontSize: "20px",
                          color: themeStyle.secondaryColor,
                          fontWeight: "bold",
                        }}
                      >
                        Inventory Information
                      </span>
                      <hr />

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Inventory Id:</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {product.inv_id ? (
                            product.inv_id
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Category:</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {product.category ? (
                            product.category
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Quantity:</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {product.quantity ? (
                            product.quantity
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Rate:</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {product.rate ? (
                            product.rate + " per unit"
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Total Price:</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {product.total_price ? (
                            product.total_price
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Perishable</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {!product.is_perishable ? (
                            "NO"
                          ) : (
                            <span style={{ color: "#ff3333" }}>YES</span>
                          )}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Expiry Date</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {product.expiry ? product.expiry : "NON PERISHABLE"}
                        </span>
                      </div>
                      <br />
                      <span
                        style={{
                          fontSize: "20px",
                          color: themeStyle.secondaryColor,
                          fontWeight: "bold",
                        }}
                      >
                        Activity
                      </span>
                      <Grid
                        container
                        spacing={2}
                        style={{
                          justifyContent: "flex-start",
                          textAlign: "left",
                          marginTop: "15px",
                          marginLeft: "0px",
                          paddingBottom: "15px",
                          color: themeStyle.primaryColorLight,
                          borderBottom: "1px solid" + themeStyle.primaryColor,
                          backgroundColor: themeStyle.secondaryColor,
                          width: "100%",
                          borderTopRightRadius: "15px",
                          borderTopLeftRadius: "15px",
                        }}
                      >
                        <Grid item md={3}>
                          Sr
                        </Grid>
                        <Grid item md={3}>
                          Date
                        </Grid>
                        <Grid item md={3}>
                          Type
                        </Grid>
                        <Grid item md={3}>
                          Value
                        </Grid>
                      </Grid>

                      <div
                        style={{
                          color: themeStyle.primaryColor,
                          marginLeft: "15px",
                        }}
                      >
                        {product.activity ? (
                          JSON.parse(product.activity).map(
                            (activity, index) => {
                              return (
                                <Grid container spacing={2}>
                                  <Grid item md={3}>
                                    {index + 1}
                                  </Grid>
                                  <Grid item md={3}>
                                    {activity.date}
                                  </Grid>
                                  <Grid item md={3}>
                                    {" "}
                                    <div
                                      style={{
                                        color:
                                          activity.type == "ADD"
                                            ? "green"
                                            : "red",
                                      }}
                                    >
                                      {activity.type}
                                    </div>
                                  </Grid>
                                  <Grid item md={3}>
                                    {activity.value}
                                  </Grid>
                                </Grid>
                              );
                            }
                          )
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </div>
                      <hr />
                      <Grid container spacing={2}>
                        <Grid item md={3}></Grid>
                        <Grid item md={3}></Grid>
                        <Grid item md={3}>
                          CURRENT
                        </Grid>
                        <Grid item md={3}>
                          {" "}
                          {product.stock ? (
                            product.stock
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item md={8}>
                    <div
                      style={{
                        border: "3px solid " + themeStyle.primaryCardColor,
                        borderRadius: "15px",
                        padding: "15px",
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        style={{
                          justifyContent: "flex-start",
                          textAlign: "left",
                          paddingBottom: "15px",
                          color: themeStyle.primaryColor,
                          borderBottom: "1px solid" + themeStyle.primaryColor,
                          backgroundColor: themeStyle.primaryCardColor,
                          width: "103.2%",
                          borderTopRightRadius: "15px",
                          borderTopLeftRadius: "15px",
                        }}
                      >
                        <Grid item md={1}>
                          Sr
                        </Grid>
                        <Grid item md={3}>
                          Inventory Name
                        </Grid>
                        <Grid item md={3}>
                          Category
                        </Grid>
                        <Grid item md={3} style={{ textAlign: "center" }}>
                          Quantity
                        </Grid>
                        <Grid item md={2} style={{ textAlign: "center" }}>
                          Expiry
                        </Grid>
                      </Grid>
                      {inventoryList.map((product, index) => (
                        <Grid
                          onClick={() => {
                            setProduct(product);
                            setImgError(false);
                          }}
                          container
                          spacing={2}
                          style={{
                            color: "black",
                            padding: "15px",
                          }}
                        >
                          <Grid item md={1}>
                            {index + 1}
                          </Grid>
                          <Grid
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setProduct(product);
                              setImgError(false);
                            }}
                            item
                            md={3}
                          >
                            {product["name"]}
                          </Grid>
                          <Grid
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setProduct(product);
                              setImgError(false);
                            }}
                            item
                            md={3}
                          >
                            {product["category"]}
                          </Grid>
                          <Grid item md={3} style={{ textAlign: "center" }}>
                            {product["quantity"]}
                          </Grid>
                          <Grid item md={2} style={{ textAlign: "center" }}>
                            {product["expiry"]}
                          </Grid>
                        </Grid>
                      ))}
                    </div>
                    {ogInventory.length > 15 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "-15px",
                          marginTop: "-15px",
                        }}
                      >
                        {Array.from(
                          Array(Math.ceil(ogInventory.length / 25)).keys()
                        ).map((temp, index) => (
                          <div
                            style={{
                              cursor: "pointer",
                              margin: "3px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "25px",
                              height: "25px",
                              borderRadius: "30px",
                              color: "white",
                              backgroundColor: themeStyle.primaryColor,
                            }}
                            onClick={() => {
                              handleCurrentPage(index + 1);
                            }}
                          >
                            {index + 1}
                          </div>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </div>
            </div>
          )}
        </div>
      );
    } else if (selectedPage == "APPROVALS") {
      return (
        <div style={{ width: "100%", padding: "25px" }}>
          {approvalsList.length == 0 ? (
            <div
              style={{
                marginTop: "200px",
                height: "100px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Fab
                  size="large"
                  style={{
                    border: "3px solid #aaa",
                    boxShadow: "none",
                    backgroundColor: "transparent",
                  }}
                  aria-label="add"
                >
                  <PriorityHighIcon
                    style={{
                      color: "grey",
                    }}
                  />
                </Fab>
                <br />
                <h4 style={{ color: "grey" }}>
                  No requests for approval submitted.
                </h4>
              </div>
            </div>
          ) : (
            approvalsList.map((approval, index) => (
              <div
                style={{
                  width: "100%",
                }}
              >
                <Box
                  p={2}
                  style={{
                    marginBottom: "15px",
                    borderRadius: "15px",
                    border:
                      approval["status"] == "PENDING"
                        ? "1.5px solid" + themeStyle.primaryColor
                        : "none",
                    backgroundColor:
                      approval["status"] == "PENDING"
                        ? "white"
                        : approval["status"] == "APPROVED"
                        ? colorList[0]
                        : colorList[2],
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "90%" }}>
                      <div style={{ marginTop: "-30px" }}>
                        <h3
                          style={{
                            color:
                              approval["status"] == "PENDING"
                                ? themeStyle.primaryColor
                                : approval["status"] == "APPROVED"
                                ? colorList2[0]
                                : colorList2[2],
                          }}
                        >
                          {approval["subject"]}
                        </h3>
                      </div>
                      <div style={{ marginTop: "-25px" }}>
                        <h4>{approval["class"]}</h4>
                      </div>
                      <div
                        style={{
                          marginTop: "-15px",
                          marginBottom: "5px",
                          lineHeight: "18px",
                        }}
                      >
                        {approval["description"]}
                      </div>
                      {approval["status"] != "PENDING" ? (
                        <div>
                          <b>
                            {approval["status"] == "APPROVED"
                              ? "Notes:"
                              : "Reason for rejection:"}
                          </b>
                          <i>{" " + approval["resolution"]}</i>
                        </div>
                      ) : (
                        <div>
                          <br></br>
                          <b>Approve / Reject</b>
                          <TextField
                            value={approval["resolution"]}
                            style={{
                              marginTop: "2px",
                              backgroundColor: "white",
                            }}
                            onChange={(e) =>
                              handleResolution(index, e.target.value)
                            }
                            fullWidth
                            placeholder="Notes / Reason for rejecting."
                            variant="outlined"
                            multiline
                            rows={4}
                          />

                          <div
                            style={{
                              display: "flex",
                              marginTop: "15px",
                              justifyContent: "flex-end",
                            }}
                          >
                            {isSubmitting ? (
                              <CircularProgress
                                style={{ marginRight: "15px" }}
                              />
                            ) : (
                              ""
                            )}
                            <Button
                              style={{
                                fontSize: "15px",
                                height: "35px",
                                marginTop: "-1px",
                                backgroundColor: colorList2[0],
                              }}
                              onClick={() => {
                                resolveApproval(
                                  approval["request_id"],
                                  "APPROVED",
                                  approval["resolution"]
                                );
                              }}
                              variant="contained"
                            >
                              <h4>Approve</h4>
                            </Button>
                            <Button
                              style={{
                                marginLeft: "15px",
                                fontSize: "15px",
                                height: "35px",
                                marginTop: "-1px",
                                backgroundColor: colorList2[2],
                              }}
                              onClick={() => {
                                resolveApproval(
                                  approval["request_id"],
                                  "REJECTED",
                                  approval["resolution"]
                                );
                              }}
                              variant="contained"
                            >
                              <h4>Reject</h4>
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        width: "100px",
                        marginTop: "8px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          textAlign="center"
                          p={1}
                          style={{
                            height: "35px",
                            width: "35px",
                            borderRadius: "60px",
                            backgroundColor:
                              approval["status"] == "PENDING"
                                ? themeStyle.primaryColor
                                : approval["status"] == "APPROVED"
                                ? colorList2[0]
                                : colorList2[2],
                            color: "white",
                          }}
                        >
                          {approval["status"] == "PENDING" ? (
                            <PriorityHighIcon
                              style={{
                                fontSize: "30px",
                                margin: "-5px 0px 0px -5px",
                              }}
                            />
                          ) : approval["status"] == "APPROVED" ? (
                            <CheckIcon
                              style={{
                                fontSize: "30px",
                                margin: "-5px 0px 0px -5px",
                              }}
                            />
                          ) : (
                            <CloseIcon
                              style={{
                                fontSize: "30px",
                                margin: "-5px 0px 0px -5px",
                              }}
                            />
                          )}
                        </Box>
                        <b
                          style={{
                            marginTop: "5px",
                            color:
                              approval["status"] == "PENDING"
                                ? themeStyle.primaryColor
                                : approval["status"] == "APPROVED"
                                ? colorList2[0]
                                : colorList2[2],
                          }}
                        >
                          {approval["status"]}
                        </b>
                      </div>
                    </div>
                  </div>
                </Box>
              </div>
            ))
          )}
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_principal) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent={"flex-end"}>
                    <Grid item md={4}>
                      {selectedPage == "INVENTORY" ? (
                        <Button
                          fullWidth
                          value={"INVENTORY"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                            }}
                          >
                            INVENTORY
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value={"INVENTORY"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            INVENTORY
                          </h3>
                        </Button>
                      )}
                    </Grid>
                    <Grid item md={4}>
                      {selectedPage == "APPROVALS" ? (
                        <Button
                          fullWidth
                          value="APPROVALS"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                            }}
                          >
                            APPROVALS
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value="APPROVALS"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            APPROVALS
                          </h3>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                }
              />

              <div
                style={{
                  margin: "45px 0px 20px 70px",
                  backgroundColor: "white",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default InventoryPrincipal;
